import { BaselineWithExperiencesEntry, ExperienceMapper } from '@ninetailed/experience.js-utils-contentful'

function hasExperiences(entry: unknown): entry is BaselineWithExperiencesEntry {
  return (entry as BaselineWithExperiencesEntry).fields?.nt_experiences !== undefined
}

export function parseExperiences(entry: unknown) {
  if (!entry || !hasExperiences(entry)) {
    return []
  }
  return entry.fields.nt_experiences.filter(ExperienceMapper.isExperienceEntry).map(ExperienceMapper.mapExperience)
}
